// extracted by mini-css-extract-plugin
export default {"root":"Section_root__5Bhzb","alternateBackgroundColor":"Section_alternateBackgroundColor__YDARg","wrapper":"Section_wrapper__LSJNq"};